import React from 'react'
import styled from 'styled-components'
import { Card } from '@pancakeswap-libs/uikit'

export const BodyWrapper = styled(Card)`
  position: relative;
  max-width: 436px;
  width: 100%;
  z-index: 5;
  border: 1px solid ${({ theme }) => (theme.isDark ? 'rgba(4, 226, 255, 0.35)' : 'rgba(22, 83, 161, 0.3)')};
  box-shadow: ${({ theme }) =>
    theme.isDark
      ? '0px 0px 0px 1px rgba(4, 226, 255, 0.08), 0px 12px 48px rgba(4, 226, 255, 0.18), 0px 4px 16px rgba(0, 0, 0, 0.55)'
      : '0px 12px 48px rgba(22, 83, 161, 0.16), 0px 4px 16px rgba(0, 0, 0, 0.1)'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #04e2ff 0%, #1653a1 50%, #04e2ff 100%);
    z-index: 6;
  }
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper>{children}</BodyWrapper>
}
